import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Topbar } from './components/Topbar';
import { Sidebar } from './components/Sidebar';
import { HomePage } from './components/HomePage';
import { ArticleView } from './components/ArticleView';
import { SearchModal } from './components/SearchModal';
import './App.css';

export function App() {
  const [searchOpen, setSearchOpen] = useState(false);

  // ⌘K / Ctrl-K opens search globally; Esc closes (handled inside the modal).
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen(true);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="app">
      <Topbar onOpenSearch={() => setSearchOpen(true)} />
      <div className="ds-shell">
        <Sidebar />
        <main className="ds-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* API area lands on its overview; /api/:slug renders an article.
                The /api/:slug route ranks above /:slug, so it wins for API URLs. */}
            <Route path="/api" element={<Navigate to="/api/api-overview" replace />} />
            <Route path="/api/:slug" element={<ArticleView />} />
            <Route path="/:slug" element={<ArticleView />} />
          </Routes>
        </main>
        {/* TOC mounts into this slot via portal when an article is active */}
        <div id="ds-toc-slot" />
      </div>
      <SearchModal open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
  );
}
